import {
  PlainReservation,
  StudentDetails,
  UnauthedPurchaserData,
} from 'lib/TutoringStateMachine/TutoringDataHelpers';
import * as CoachingActions from 'coaching/actions/CoachingActions';

export type TypeMarker<T> = {};
export function typeMarker<T>(): TypeMarker<T> {
  return {};
}

export const TutoringStorages = {
  savedReservation: {
    namespace: 'savedReservation',
    type: typeMarker<{
      selectedReservation: PlainReservation;
      reservationUuid: string;
      selectedUserTimezone: string;
    }>(),
  },
  availabilityQuery: {
    namespace: 'availabilityQuery',
    type: typeMarker<CoachingActions.CoachingAvailabilityResponse>(),
  },
  unauthedPurchaserDetails: {
    namespace: 'purchaserDetails',
    type: typeMarker<UnauthedPurchaserData>(),
  },
  studentDetails: {
    namespace: 'studentDetails',
    type: typeMarker<StudentDetails>(),
  },
  purchaseCompleted: {
    namespace: 'billingCompleted',
    type: typeMarker<boolean>(),
  },
  linkStudentCompleted: {
    namespace: 'linkStudentCompleted',
    type: typeMarker<boolean>(),
  },
  purchaseResult: {
    namespace: 'purchaseResult',
    type: typeMarker<{
      participantUUID: string;
      linkStudentToken?: string;
    }>(),
  },
} as const;

export type StorageLocation<StorageType> = {
  namespace: string;
  type: TypeMarker<StorageType>;
};

const rootNamespace = 'tutoring_streamlined_v2';

export function saveToStorage<StorageType>(
  state: StorageLocation<StorageType>,
  payload: StorageType
) {
  window.sessionStorage.setItem(`${rootNamespace}:${state.namespace}`, JSON.stringify(payload));
}

/**
 * Retrieve the data associated with a specific state from sessionStorage
 * **/
export function retrieveFromStorage<StorageType>(
  state: StorageLocation<StorageType>
): StorageType | null {
  const itemLocalStorage = window.sessionStorage.getItem(`${rootNamespace}:${state?.namespace}`);
  if (!itemLocalStorage) return null;
  try {
    return JSON.parse(itemLocalStorage);
  } catch (error) {
    console.error(`Error getting data for location ${state.namespace}`);
    return null;
  }
}

export function clearStorage<T>(storage: StorageLocation<T>) {
  window.sessionStorage.removeItem(`${rootNamespace}:${storage?.namespace}`);
}

export function clearSignupStorage() {
  try {
    const storages = TutoringStorages;
    Object.entries(storages).forEach(([_, storageLocation]) => {
      clearStorage(storageLocation);
    });
  } catch (e) {
    console.error(`Could not clear storage ${e}`);
  }
}
